import { render, staticRenderFns } from "./payBox.vue?vue&type=template&id=e7d85c86&scoped=true"
import script from "./payBox.vue?vue&type=script&lang=js"
export * from "./payBox.vue?vue&type=script&lang=js"
import style0 from "./payBox.vue?vue&type=style&index=0&id=e7d85c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d85c86",
  null
  
)

export default component.exports